import {
	useBlockProps,
	InnerBlocks,
	InspectorControls,
} from '@wordpress/block-editor';
import {
	TextControl,
	PanelBody,
	PanelRow,
	Dashicon,
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { useEffect } from '@wordpress/element';

export default function Edit({ attributes, setAttributes, clientId }) {
	const { title, blockId } = attributes;

	useEffect(() => {
		if (!blockId) {
			setAttributes({ blockId: clientId });
		}
	}, [blockId, clientId]);

	const blockProps = useBlockProps();

	return (
		<>
			<div {...blockProps}>
				<Dashicon icon="design" />
				<div className="bem-ipmcollapseblock--accordion wp-block-ipm-collapseblock accordion accordion-flush">
					<div className="bem-ipmcollapseblock--item accordion-item">
						<h2 className="accordion-header">
							<button className="bem-ipmcollapseblock--header accordion-button collapsed">
								<div className="bem-ipmcollapseblock--title">
									<TextControl
										className="bem-collapseblock_title"
										label={__('Text to displayed when collapse.', 'ipm-collapseblock-save-title-label')}
										placeholder={__('Collapsed Text Preview.', 'ipm-collapseblock-save-title-placeholder')}
										value={title}
										onChange={(value) => setAttributes({ title: value })}
									/>
								</div>
							</button>
						</h2>
					</div>
				</div>

				<InnerBlocks />
			</div>

			<InspectorControls>
				<PanelBody title={__('Collapse Settings')} initialOpen>
					<PanelRow>
						<TextControl
							label={__('Text to displayed when block is collapsed.')}
							placeholder={__('Preview Text for collapsing block.')}
							value={title}
							onChange={(value) => setAttributes({ title: value })}
						/>
					</PanelRow>
				</PanelBody>
			</InspectorControls>
		</>
	);
}
